module.exports = __webpack_public_path__ + "img/br3gj.a2337342.png";